import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Button';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = () => ({
  root: {
    position: 'fixed',
    bottom: 20,
    left: 20,
    zIndex: 100000,
  },
});

const DebugPanelButton = ({
  className,
  classes,
  onClick,
}) => {
  return (
    <Button
      className={classNames(classes.root, className)}
      onClick={onClick}
      color="red"
      variant="contained"
    >
      {'Open Debug Panel'}
    </Button>
  );
};

DebugPanelButton.defaultProps = {
  className: '',
};

DebugPanelButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default withStyles(styles)(DebugPanelButton);
